var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-overlay',{attrs:{"value":true,"absolute":""}},[_c('v-progress-circular',{attrs:{"width":5,"color":"white","size":"70","indeterminate":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }